var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import EPopper from '@common/ui/EPopper/EPopper.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ETooltip',
    props: /*#__PURE__*/ _mergeModels({
        allowedPlacements: { default: function () { return ['top', 'bottom']; } },
        offsetAmount: { default: 10 },
        appendToBody: { type: Boolean, default: true },
        trigger: { default: 'hover' },
        unselectable: { type: Boolean, default: false },
        tooltipText: { default: '' },
        theme: { default: 'dark' },
        disabled: { type: Boolean, default: false },
        hideArrow: { type: Boolean, default: false },
        fullwidth: { type: Boolean },
        fullwidthParent: { type: Boolean },
        inline: { type: Boolean },
        renderType: {}
    }, {
        "visible": __assign({ type: Boolean }, { default: false }),
        "visibleModifiers": {},
    }),
    emits: ["update:visible"],
    setup: function (__props) {
        var props = __props;
        var themeClass = computed(function () {
            return {
                dark: 'e-tooltip__reference--dark',
                light: 'e-tooltip__reference--light'
            }[props.theme];
        });
        var themeClassArrow = computed(function () {
            return {
                dark: 'e-tooltip__arrow--dark',
                light: 'e-tooltip__arrow--light'
            }[props.theme];
        });
        var visibleModel = _useModel(__props, 'visible');
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EPopper, {
                visible: visibleModel.value,
                "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) { return ((visibleModel).value = $event); }),
                "allowed-placements": _ctx.allowedPlacements,
                "append-to-body": _ctx.appendToBody,
                class: _normalizeClass([[
                        _ctx.inline && 'inline-flex'
                    ], "e-tooltip"]),
                disabled: _ctx.disabled,
                fullwidth: _ctx.fullwidth,
                "fullwidth-parent": _ctx.fullwidthParent,
                "hide-arrow": _ctx.hideArrow,
                inline: _ctx.inline,
                "offset-amount": _ctx.offsetAmount,
                "render-type": _ctx.renderType,
                trigger: _ctx.trigger,
                unselectable: _ctx.unselectable
            }, {
                reference: _withCtx(function () { return [
                    _createElementVNode("div", {
                        class: _normalizeClass([[
                                themeClass.value
                            ], "e-tooltip__reference"])
                    }, [
                        _renderSlot(_ctx.$slots, "tooltip", {}, function () { return [
                            _createTextVNode(_toDisplayString(_ctx.tooltipText), 1)
                        ]; })
                    ], 2)
                ]; }),
                arrow: _withCtx(function () { return [
                    _createElementVNode("div", {
                        class: _normalizeClass([[themeClassArrow.value], "e-tooltip__arrow"])
                    }, null, 2)
                ]; }),
                default: _withCtx(function () { return [
                    _renderSlot(_ctx.$slots, "default")
                ]; }),
                _: 3
            }, 8, ["visible", "allowed-placements", "append-to-body", "class", "disabled", "fullwidth", "fullwidth-parent", "hide-arrow", "inline", "offset-amount", "render-type", "trigger", "unselectable"]));
        };
    }
});
